import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import FileViewPage from "./FileViewPage";
import { api } from "../utils/axios-instance";

const StandaloneFileViewer = () => {
  const { fileId } = useParams();

  const [loading, setLoading] = useState(true);

  const [fileInfo, setFileInfo] = useState(null);

  const [sharedFileInfo, setSharedFileInfo] = useState({});

  useEffect(() => {
    fetchFile();
  }, [fileId]);

  const fetchFile = async () => {
    try {
      setLoading(true);

      // fetch all files
      const response = await api.get("/file/files");

      const files = response.data || [];

      const file = files.find((f) => f.id === fileId);

      if (!file) {
        setLoading(false);
        return;
      }

      // fetch shared info
      try {
        const sharedInfoRes = await api.get(`/file/sharedFileInfo/${fileId}/`);

        setSharedFileInfo(sharedInfoRes.data || {});
      } catch (err) {
        console.log(err);
      }

      // build normalized object
      const normalizedFile = {
        id: file.id,
        name: file.name,
        owner: file.owner_id,

        mimetype: file?.metadata?.mimetype || file?.metadata?.mimeType || "",

        size: file?.metadata?.size,

        download_url: file?.download_url,

        currVersion: file?.versioning?.curr_version || "",

        versions: file?.versioning?.versions || [],

        color: file?.color || "#3498db",

        department_ids: file?.department_ids || [],

        folder_id: file?.folder_id || null,
      };

      setFileInfo(normalizedFile);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const closeDrawer = () => {
    window.history.back();
  };

  if (loading) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        Loading file...
      </div>
    );
  }

  if (!fileInfo) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        File not found
      </div>
    );
  }

  return (
    <FileViewPage
      fileInfo={fileInfo}
      closeDrawer={closeDrawer}
      sharedFileInfo={sharedFileInfo}
    />
  );
};

export default StandaloneFileViewer;
